module.exports = __webpack_public_path__ + "img/i-community-gold.ecf05867.svg";